<template>
    <div class="mb-2">
        <div class="events">
            <div class="events__header">
                <div class="container">
                    <h1 class="events__title">Календарь мероприятий</h1>
                </div>
            </div>
            <div class="container">
                <div class="grid">
                    <div class="grid__col grid__col--lg-3">
                        <div class="events__datepicker">
                            <div class="events__arr" @click="prevMonth">
                                <img src="/design_kit/site/blocks/events/img/prev.svg" alt="Предыдущий месяц">
                            </div>
                            <div class="events__dates">
                                {{
                                    this.dataLoaded ? this.langMonth[this.selectedMonth] + ' ' + this.selectedYear : ''
                                }}
                            </div>
                            <div class="events__arr" @click="nextMonth">
                                <img src="/design_kit/site/blocks/events/img/next.svg" alt="Следующий месяц">
                            </div>
                        </div>

                        <div class="events__filters">
                            <div class="events__filters_title">Фильтры мероприятий</div>
                            <div
                                class="events__filter"
                                :class="item.css + (filter.includes(item.ID) ? ' events__filter--active' : '')"
                                :id="'filter-section-' + item.ID"
                                :data-value="item.ID"
                                v-for="(item, key) in this.sections"
                                :key="filter + '_' + sections + '_' + key"
                                @click="setFilter(item.ID)"
                            >{{ item.NAME }}
                            </div>
                            <div><span class="events__clear" @click="resetFilter">Очистить фильтры</span></div>
                        </div>
                        <div class="events__form">
                            <form method="post" action="/ajax_new/events.php"
                                  @submit.prevent="formSubscribeHandler($event.target)">
                                <div class="events__subscribe">
                                    <div class="events__wrap">Подпишитесь на&nbsp;новости о&nbsp;мероприятиях</div>
                                    <div class="events__newspaper">
                                        <img src="/design_kit/site/blocks/events/img/news.svg" alt="Новости">
                                    </div>
                                </div>
                                <div class="input events__input">
                                    <input name="email" class="input__field" type="text" placeholder="Введите E-mail">
                                </div>
                                <div class="chbox mb-1">
                                    <input type="checkbox" name="pdAgreed" class="chbox__input" id="pdAgreed">
                                    <label for="pdAgreed" class="chbox__label">
                                        Я даю согласие на <a href="/policies/personal-agreement/" target="_blank">обработку
                                        своих данных</a>
                                    </label>
                                </div>
                                <div class="chbox mb-2">
                                    <input type="checkbox" name="advertAgreed" class="chbox__input" id="advertAgreed">
                                    <label for="advertAgreed" class="chbox__label">
                                        Я согласен на&nbsp;<a
                                        href="/policies/advertising-consent/">получение
                                        рекламной информации</a>
                                        о&nbsp;продуктах и&nbsp;услугах, экспертных материалов, новостях,
                                        информации о&nbsp;текущих акциях и&nbsp;бонусах по&nbsp;предоставленным каналам
                                        связи
                                    </label>
                                </div>
                                <input type="submit" class="button events__send" value="Отправить">
                            </form>
                        </div>

                        <div class="events__links">
                            <div class="events__socials">
                                Мы в соц.сетях
                            </div>
                            <div>
                                <a href="https://vk.com/mangotelecom" target="_blank" class="events__social"><img
                                    src="/design_kit/site/blocks/events/img/vk.svg" alt="ВКонтакте"></a>
                                <a href="https://www.youtube.com/mangotelecom" target="_blank"
                                   class="events__social"><img
                                    src="/design_kit/site/blocks/events/img/youtube.svg" alt="YouTube"></a>
                                <a href="https://t.me/mango_office" target="_blank" class="events__social"><img
                                    src="/design_kit/site/blocks/events/img/tg.svg" alt="Telegram"></a>
                            </div>
                        </div>
                    </div>
                    <div class="grid__col grid__col--lg-9" :set="rows = this.rows">
                        <div class="events__days">
                            <div class="events__weekday">Понедельник</div>
                            <div class="events__weekday">Вторник</div>
                            <div class="events__weekday">Среда</div>
                            <div class="events__weekday">Четверг</div>
                            <div class="events__weekday">Пятница</div>
                            <div class="events__weekday">Суббота</div>
                            <div class="events__weekday">Воскресенье</div>
                        </div>
                        <div class="events__week"
                             v-for="(week, keyWeek) in this.month"
                             :key="week + '_' + keyWeek"
                        >
                            <div class="events__daynum"
                                 v-for="(day, keyDay) in week"
                                 :key="day + '_' + keyDay"
                            >
                                <div
                                    class="events__num"
                                    :class="day.css"
                                >{{ day.day }}
                                </div>
                            </div>
                            <div class="events__info"
                                 :class="event.cssParent"
                                 v-for="(event, keyEvent) in rows[keyWeek]"
                                 :key="keyWeek + '_' + event + '_' + keyEvent"
                            >
                                <div class="events__event"
                                     :data-id="event.id"
                                     :class="event.css"
                                     v-if="event.name"
                                     @click="loadEvent(event.id)"
                                >
                                    {{ event.name }}
                                </div>
                                <span class="events__tooltip" v-if="event.name">{{ event.name }}</span>
                            </div>
                        </div>
                        <div class="container">
                            <div class="events__icall">
                                <div class="events__icall_title">Вы можете добавить все события месяца к себе в
                                    календарь.
                                </div>
                                <span class="events__icall_btn button button--outline"
                                      @click="iCall">Добавить в iCal</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <CalendarModal
            :detail-loaded="this.detailLoaded"
            :detail-event="this.detailEvent"
            :filter="this.filter"
            v-on:load="loadEvent"
        />
    </div>
</template>

<script>
import calendarMethods from '../../lib/calendarMethods.js';
import CalendarModal from '../../components/CalendarModal.vue';

export default {
    name: 'Calendar',
    components: {
        CalendarModal
    },
    mixins: [calendarMethods],
    data() {
        return {
            ids: [],
            month: [],
            rows: [],
        }
    },
    props: {
        langMonth: {
            type: Object,
            default() {
                return {
                    0: 'Январь',
                    1: 'Февраль',
                    2: 'Март',
                    3: 'Апрель',
                    4: 'Май',
                    5: 'Июнь',
                    6: 'Июль',
                    7: 'Август',
                    8: 'Сентябрь',
                    9: 'Октябрь',
                    10: 'Ноябрь',
                    11: 'Декабрь',
                };
            }
        }
    },
    mounted: function () {
        let date = new Date();
        this.nowDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        this.selectedMonth = this.nowDate.getMonth();
        this.selectedYear = this.nowDate.getFullYear();
        this.request();
    },
    methods: {
        initCurrent() {
            this.setCurrentMonth();
        },
        nextMonth() {
            if (this.selectedMonth === 11) {
                this.selectedMonth = 0;
                this.selectedYear++;
            } else {
                this.selectedMonth++;
            }
            this.setCurrentMonth();
        },
        prevMonth() {
            if (this.selectedMonth === 0) {
                this.selectedMonth = 11;
                this.selectedYear--;
            } else {
                this.selectedMonth--;
            }
            this.setCurrentMonth();
        },
        setCurrentMonth() {
            // Первый день недели в выбранном месяце
            let firstDayOfMonth = new Date(this.selectedYear, this.selectedMonth, 7).getDay();
            // Последний день выбранного месяца
            let lastDateOfMonth = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate();

            let currentDate = this.nowDate.getDate();
            let currentMonth = this.nowDate.getMonth();
            let currentYear = this.nowDate.getFullYear();
            this.ids = [];
            this.month = [];
            let i = 1;
            let week = [];
            let eventsMap = this.eventsMap;
            let skip = [];
            do {
                let iday = new Date(this.selectedYear, this.selectedMonth, i);
                let dow = iday.getDay();
                let current = (iday.getTime() === this.nowDate.getTime());
                let future = (iday.getTime() > this.nowDate.getTime());
                let old = (iday.getTime() < this.nowDate.getTime());

                // Если первый день недели - не понедельник, показать последние дни предыдущего месяца
                if (dow !== 1 && i === 1) {
                    for (let j = 0; j < firstDayOfMonth; j++) {
                        week.push({
                            'events': []
                        });
                    }
                }

                // Записываем текущий день в цикл
                let events = [];
                let key = iday.getFullYear() + '_' + (iday.getMonth() + 1) + '_' + i;
                if (typeof eventsMap[key] !== "undefined") {
                    for (let event in eventsMap[key]) {
                        if (skip.includes(key + '_' + eventsMap[key][event])) {
                            continue;
                        }
                        let item = this.events[eventsMap[key][event]];
                        if (!this.filter.length || this.filter.includes(item.IBLOCK_SECTION_ID)) {
                            let css = 'events__event--default';
                            if (typeof this.sections[item.IBLOCK_SECTION_ID] !== "undefined") {
                                css = 'events__event--' + this.sections[item.IBLOCK_SECTION_ID]['XML_ID'];
                            }
                            if (typeof this.sectionCss[item.IBLOCK_SECTION_ID] !== "undefined") {
                                css = 'events__event--' + this.sectionCss[item.IBLOCK_SECTION_ID];
                            }
                            let oldEvent = old;
                            let length = 1;
                            if (dow !== 0) {
                                let i2 = 1;
                                while (dow + i2 <= 7) {
                                    let nday = i + (i2 === 7 ? 0 : i2);
                                    if (nday > lastDateOfMonth) {
                                        break;
                                    }
                                    let key2 = iday.getFullYear() + '_' + (iday.getMonth() + 1) + '_' + nday;
                                    if (typeof eventsMap[key2] !== "undefined") {
                                        let present = false;
                                        for (let index in eventsMap[key2]) {
                                            if (eventsMap[key2][index] === eventsMap[key][event]) {
                                                length++;
                                                skip.push(key2 + '_' + eventsMap[key][event]);
                                                i2++;
                                                present = true;
                                                if (oldEvent && nday >= currentDate && iday.getMonth() === currentMonth && iday.getFullYear() === currentYear) {
                                                    oldEvent = false;
                                                }
                                                break;
                                            }
                                        }
                                        if (present) {
                                            continue;
                                        }
                                    }
                                    break;
                                }
                            }
                            let cssParent = '';
                            if (length > 1) {
                                cssParent = 'events__info--' + length;
                            }
                            if (oldEvent) {
                                css += ' events__event--outer';
                                cssParent += ' events__info--past';
                            }
                            events.push({
                                'id': item.ID,
                                'name': item.NAME,
                                'css': css,
                                'cssParent': cssParent,
                                'length': length
                            });
                            this.ids.push(item.ID);
                        }
                    }
                }
                let css = '';
                if (current) {
                    css = 'events__num--now';
                } else if (future) {
                    css = 'events__num--future';
                }
                week.push({
                    'day': i,
                    'css': css,
                    'events': events
                });
                // закрыть строку в воскресенье
                if (dow === 0) {
                    this.month.push(week);
                    week = [];
                }
                // Если последний день месяца не воскресенье, показать первые дни следующего месяца
                else if (i === lastDateOfMonth) {
                    for (dow; dow < 7; dow++) {
                        week.push({
                            'events': []
                        });
                    }
                    this.month.push(week);
                }
                i++;
            } while (i <= lastDateOfMonth);

            this.rows = [];
            let imax = 0;
            for (let wom in this.month) {
                let week = this.month[wom];
                let rows = [];
                let dow = 0;
                let empty = true;
                do {
                    imax++;
                    if (typeof week[dow] !== "undefined" && week[dow]['events'].length > 0) {
                        let maxLength = 0;
                        for (let index in week[dow]['events']) {
                            if (maxLength < week[dow]['events'][index]['length']) {
                                maxLength = week[dow]['events'][index]['length'];
                            }
                        }
                        if (!maxLength) {
                            week[dow]['events'] = [];
                            rows.push({});
                            dow++;
                        } else {
                            for (let index in week[dow]['events']) {
                                if (maxLength === week[dow]['events'][index]['length']) {
                                    let len = week[dow]['events'][index]['length'];
                                    rows.push(week[dow]['events'][index]);
                                    delete week[dow]['events'][index];
                                    dow += len;
                                    empty = false;
                                    break;
                                }
                            }
                        }
                    } else {
                        rows.push({});
                        dow++;
                    }
                    if (dow > 6) {
                        if (!empty) {
                            dow = 0;
                            empty = true;
                        } else {
                            break;
                        }
                    }
                } while (imax < 5000);
                this.rows.push(rows);
            }
        }
    }
}
</script>

<style lang="scss">
@import "../../../../design_kit/site/blocks/test_page/style.scss";
@import "../../../../design_kit/site/blocks/grid/style.scss";
@import "../../../../design_kit/site/blocks/section/style.scss";
@import "../../../../design_kit/site/blocks/button/style.scss";
@import "../../../../design_kit/site/blocks/popup/style.scss";
@import "../../../../design_kit/site/blocks/input/style.scss";
@import "../../../../design_kit/site/blocks/events/style.scss";
</style>
